import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Sidebar from "../../component/Sidebar";
import Topbar from "../../component/Topbar";
import { baseurl, imgurl } from "../../baseurl";
import axios from "axios";
import { FiArrowLeft, FiPrinter } from "react-icons/fi";

function ViewOrder() {
  const { order_uuid } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  const handlePrint = () => {
    window.print();
  };

  const fetchOrder = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${baseurl}getOrderDetailsById/${order_uuid}`);
      if (res.data.success) {
        setOrder(res.data.order);
      }
    } catch (err) {
      console.error("Error fetching order details:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (order_uuid) fetchOrder();
  }, [order_uuid]);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('en-IN');
  };

  const formatInvoiceNo = (id) => {
    return `SCIM/25-26/${String(id).padStart(6, '0')}`;
  };

  const calculateTax = (amount) => {
    return (amount * 0.09).toFixed(2);
  };

  if (loading) {
    return (
      <>
        <div className="d-print-none"><Topbar /><Sidebar /></div>
        <main className="main-wrapper p-5 text-center">
          <div className="spinner-border text-primary" role="status"></div>
          <div className="mt-2">Loading Invoice...</div>
        </main>
      </>
    );
  }

  if (!order) {
    return (
      <>
        <div className="d-print-none"><Topbar /><Sidebar /></div>
        <main className="main-wrapper p-5 text-center text-danger">Order not found.</main>
      </>
    );
  }

  const totalItems = order.items?.reduce((acc, item) => acc + item.quantity, 0) || 0;
  const taxableValue = order.totals?.total_amount || 0;
  const sgst = calculateTax(taxableValue);
  const cgst = calculateTax(taxableValue);
  const grandTotal = parseFloat(taxableValue) + parseFloat(sgst) + parseFloat(cgst);

  return (
    <>
      <div className="d-print-none">
        <Topbar />
        <Sidebar />
      </div>

      <main className="main-wrapper p-3 p-lg-4" style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
        
        {/* Action Toolbar */}
        <div className="container d-print-none mb-4 d-flex justify-content-between align-items-center" style={{ maxWidth: "900px" }}>
          <button className="btn btn-light border shadow-sm" onClick={() => navigate(-1)}>
            <FiArrowLeft className="me-2" /> Back
          </button>
          <button className="btn btn-primary shadow-sm" onClick={handlePrint}>
            <FiPrinter className="me-2" /> Print Invoice
          </button>
        </div>

        {/* Invoice Container */}
        <div className="invoice-container printable-area">
          
          {/* Header Section */}
          <div className="header-section">
            <div className="header-left">
              <div className="logo-box">
                <h1 className="company-name">SUBCITY</h1>
                <p className="company-tagline">SHOP MORE, PAY LESS</p>
              </div>
            </div>
            <div className="header-center">
              <h2 className="invoice-title">TAX INVOICE</h2>
              <p className="invoice-subtitle">(ORIGINAL FOR RECIPIENT)</p>
              <p className="invoice-note">(Issued under Section 31 of CGST Act, 2017)</p>
            </div>
            <div className="header-right">
              <table className="header-table">
                <tbody>
                  <tr>
                    <td className="header-label">Invoice No.</td>
                    <td className="header-value">{formatInvoiceNo(order.order_id)}</td>
                  </tr>
                  <tr>
                    <td className="header-label">Invoice Date</td>
                    <td className="header-value">{formatDate(order.created_at)}</td>
                  </tr>
                  <tr>
                    <td className="header-label">Order No.</td>
                    <td className="header-value">{order.order_id}</td>
                  </tr>
                  {/* <tr>
                    <td className="header-label">Order Date</td>
                    <td className="header-value">{formatDate(order.created_at)}</td>
                  </tr>
                  <tr>
                    <td className="header-label">Place of Supply</td>
                    <td className="header-value">ASSAM (18)</td>
                  </tr>
                  <tr>
                    <td className="header-label">Reverse Charge</td>
                    <td className="header-value">No</td>
                  </tr> */}
                </tbody>
              </table>
            </div>
          </div>

          {/* Billing Section */}
          <div className="billing-section">
            <div className="billing-from">
              <h3 className="section-title">BILLING FROM</h3>
               
              <div className="company-info">
                <p className="fw-bold">Subcity International Marketing Pvt Ltd</p>
                <p>Paliguri, Jagiroad, Morigaon,<br />Assam - 782410, India</p>
                <p>Mobile No.: 8876499739<br />GSTIN/UIN: 18AABCS1234M1ZP</p>
                {/* <p>State Code : 18 - ASSAM</p> */}
                <p>CIN: U74999AS2023PTC023456</p>
                <p>E-Mail: support@subcity.in</p>
              </div>
            </div>

            <div className="shipment-from">
              <h3 className="section-title">SHIPMENT FROM (VENDOR)</h3>
              <div className="company-info">
  <p className="fw-bold">{order.vendors?.[0]?.business_name || order.vendors?.[0]?.name}</p>
  <p>
    {order.vendors?.[0]?.address?.address_line1} {order.vendors?.[0]?.address?.address_line2}, 
    {order.vendors?.[0]?.address?.city}, {order.vendors?.[0]?.address?.state}, 
    {order.vendors?.[0]?.address?.country}, {order.vendors?.[0]?.address?.postal_code}
  </p>
  <p>
    Mobile No.: {order.vendors?.[0]?.phone}<br />
    GSTIN/UIN: {order.vendors?.[0]?.gst_number || "N/A"}
  </p>
  {/* <p>State Code : 18 - ASSAM</p> */}
  <p>E-Mail: {order.vendors?.[0]?.email}</p>
</div>
            </div>
          </div>

          {/* Customer Details */}
          <div className="customer-section">
            <div className="billed-to">
              <h3 className="section-title">BILLED TO (CONSIGNEE)</h3>
              <div className="customer-info">
                <p className="fw-bold">{order.customer_name}</p>
                <p>{order.shipping?.address || order.customer_address || 'Address not provided'} {order.shipping?.city || ''}, {order.shipping?.state || ''} - {order.shipping?.pincode || ''}</p>
                {/* <p>{order.shipping?.city || ''}, {order.shipping?.state || ''} - {order.shipping?.pincode || ''}</p> */}
                {/* <p>State Code : 18 - ASSAM</p> */}
                <p>Place of Supply : {order.shipping?.state?.toUpperCase() || 'ASSAM'}</p>
                <p>Mobile No.: {order.customer_phone}</p>
              </div>
            </div>

            <div className="shipped-to">
              <h3 className="section-title">SHIP TO</h3>
              <div className="customer-info">
                <p className="fw-bold">{order.shipping?.fullName || order.customer_name}</p>
                <p>{order.shipping?.address || order.customer_address || 'Address not provided'} {order.shipping?.city || ''}, {order.shipping?.state || ''} - {order.shipping?.pincode || ''}</p>
                {/* <p>{order.shipping?.city || ''}, {order.shipping?.state || ''} - {order.shipping?.pincode || ''}</p> */}
                {/* <p>State Code : 18 - ASSAM</p> */}
                <p>Place of Supply : {order.shipping?.state?.toUpperCase() || 'ASSAM'}</p>
                <p>Mobile No.: {order.shipping?.phone || order.customer_phone}</p>
              </div>
            </div>
          </div>

          {/* Invoice Details */}
          {/* <div className="invoice-details-row">
            <p>Invoice Type: Regular | Supply Type: Inter-State Supply</p>
          </div> */}

          {/* Items Table */}
          <div className="items-table-wrapper">
            <table className="items-table">
              <thead>
                <tr>
                  <th>Sl. No.</th>
                  <th>Description of Goods / Services</th>
                  <th>HSN/SAC</th>
                  <th>Qty</th>
                  <th>Unit</th>
                  <th>Unit Price (₹)</th>
                  <th>Discount (₹)</th>
                  <th>Taxable Value (₹)</th>
                  <th colSpan="2">SGST 9%</th>
                  <th colSpan="2">CGST 9%</th>
                  <th>Total Amount (₹)</th>
                </tr>
                <tr>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th></th>
                  <th>Rate (%)</th>
                  <th>Amount (₹)</th>
                  <th>Rate (%)</th>
                  <th>Amount (₹)</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {order.items?.map((item, idx) => (
                  <tr key={idx}>
                    <td className="text-center">{idx + 1}</td>
                    <td className="item-description">
                      <div className="fw-bold">{item.product_name}</div>
                      {item.variant_name && <span className="item-variant">Variant: {item.variant_name}</span>}
                    </td>
                    <td className="text-center">9042100</td>
                    <td className="text-center">{item.quantity}</td>
                    <td className="text-center">Nos</td>
                    <td className="text-right">₹{Number(item.price).toLocaleString('en-IN')}</td>
                    <td className="text-right">0.00</td>
                    <td className="text-right">₹{Number(item.price).toLocaleString('en-IN')}</td>
                    <td className="text-center">9%</td>
                    <td className="text-right">₹{calculateTax(item.price)}</td>
                    <td className="text-center">9%</td>
                    <td className="text-right">₹{calculateTax(item.price)}</td>
                    <td className="text-right fw-bold">₹{(parseFloat(item.price) * 1.18).toFixed(2)}</td>
                  </tr>
                ))}
                <tr className="totals-row">
                  <td colSpan="3" className="text-center fw-bold">Total Items: {order.items?.length || 0}</td>
                  <td className="text-center fw-bold">{totalItems}</td>
                  <td colSpan="3"></td>
                  <td className="text-right fw-bold">₹{Number(taxableValue).toLocaleString('en-IN')}</td>
                  <td></td>
                  <td className="text-right fw-bold">₹{sgst}</td>
                  <td></td>
                  <td className="text-right fw-bold">₹{cgst}</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Totals Section */}
          <div className="totals-section">
            <div className="totals-left">
              <div className="total-words">
                <p className="fw-bold">Total Amount (in words):</p>
                <p>Rupees {Number(taxableValue).toLocaleString('en-IN')} only</p>
              </div>
            </div>
            <div className="totals-right">
              <table className="summary-table">
                <tr>
                  <td className="summary-label">Taxable Value</td>
                  <td className="summary-value">₹{Number(taxableValue).toLocaleString('en-IN')}</td>
                </tr>
                <tr>
                  <td className="summary-label">SGST @ 9%</td>
                  <td className="summary-value">₹{sgst}</td>
                </tr>
                <tr>
                  <td className="summary-label">CGST @ 9%</td>
                  <td className="summary-value">₹{cgst}</td>
                </tr>
                <tr>
                  <td className="summary-label">Total Tax Amount</td>
                  <td className="summary-value">₹{(parseFloat(sgst) + parseFloat(cgst)).toFixed(2)}</td>
                </tr>
                <tr className="grand-total-row">
                  <td className="summary-label">Grand Total</td>
                  <td className="summary-value">₹{grandTotal.toFixed(2)}</td>
                </tr>
              </table>
            </div>
          </div>

          {/* Additional Details */}
          <div className="additional-details">
            <div className="details-left">
              <h4 className="detail-heading">E-COMMERCE OPERATOR DETAILS</h4>
              <p><strong>Name :</strong> Subcity International Marketing Pvt Ltd</p>
              <p><strong>GSTIN/UIN :</strong> 18AABCS1234M1ZP</p>
              <p><strong>Address :</strong> Paliguri, Jagiroad, Morigaon, Assam - 782410, India</p>
              <p><strong>E-Mail :</strong> support@subcity.in</p>
              <p><strong>Contact No. :</strong> 8876499739</p>

              <h4 className="detail-heading">BANK DETAILS</h4>
              <p><strong>Bank Name :</strong> State Bank of India</p>
              <p><strong>A/c Name :</strong> Subcity International marketing Pvt Ltd</p>
              <p><strong>A/c No. :</strong> 20510534705</p>
              <p><strong>IFSC Code :</strong> SBIN0002068</p>
              <p><strong>Branch :</strong> Jagiroad</p>
            </div>

            <div className="details-right">
              <h4 className="detail-heading">TRANSPORT DETAILS</h4>
              <p><strong>Courier Partner :</strong> Amazon Transportation Services</p>
              <p><strong>AWB / Tracking No. :</strong> 12345678901</p>
              <p><strong>Date of Dispatch :</strong> {formatDate(order.created_at)}</p>

              <h4 className="detail-heading">PAYMENT DETAILS</h4>
              <p><strong>Payment Mode :</strong> {order.payment_method?.toUpperCase() || 'COD'}</p>
              <p><strong>Amount Received :</strong> ₹{grandTotal.toFixed(2)}</p>
              <p><strong>Transaction ID :</strong> {order.order_uuid?.substring(0, 12).toUpperCase()}</p>
              <p><strong>Date :</strong> {formatDate(order.created_at)}</p>

              <div className="signature-area">
                <p className="fw-bold mt-4">For Subcity International Marketing Pvt Ltd</p>
                <div className="signature-line">Signature</div>
                <p className="fw-bold">Authorised Signatory</p>
                <div className="seal-line">SEAL</div>
              </div>
            </div>
          </div>

          {/* Terms & Conditions */}
          <div className="terms-section">
            <h4 className="section-title">TERMS & CONDITIONS</h4>
            <div className="terms-content">
              <ol>
                <li>This is a computer generated invoice and does not require physical signature.</li>
                <li>Goods once sold will not be taken back or exchanged.</li>
                <li>Warranty, if any, will be as per manufacturer / brand policy.</li>
                <li>Goods are dispatched after proper quality check.</li>
                <li>Any disputes are subject to Jurisdiction of Courts in Assam only.</li>
                <li>Device/Accessories need to be returned in original packaging along with all accessories, invoice & warranty card.</li>
                <li>E & O E</li>
              </ol>
            </div>

            <h4 className="section-title">IMPORTANT NOTES</h4>
            <div className="important-notes">
              <ul>
                <li>Please retain this invoice for warranty and future reference.</li>
                <li>Visit www.subcity.in for return and refund policy.</li>
                <li>For any queries, contact our support team.</li>
              </ul>
              <div className="tax-notice">
                <p>This is a Tax Invoice issued under the provisions of CGST Act, 2017 and IGST Act, 2017.</p>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="invoice-footer">
            <span>📞 8876499739</span>
            <span>📧 support@subcity.in</span>
            <span>🌐 www.subcity.in</span>
          </div>
        </div>
      </main>

      <style>{`
        .invoice-container {
          max-width: 900px;
          margin: 0 auto;
          background: white;
          padding: 20px;
          font-family: 'Arial', sans-serif;
          color: #333;
          border: 1px solid #e0e0e0;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
        }

        .printable-area {
          page-break-after: always;
        }

        /* Header Section */
        .header-section {
          display: grid;
          grid-template-columns: 1fr 1.5fr 1.5fr;
          gap: 20px;
          margin-bottom: 20px;
          border-bottom: 2px solid #003d82;
          padding-bottom: 15px;
          align-items: center;
        }

        .logo-box {
          text-align: center;
        }

        .company-name {
          font-size: 28px;
          font-weight: bold;
          color: #003d82;
          margin: 0;
        }

        .company-tagline {
          font-size: 11px;
          color: #d32f2f;
          margin: 3px 0 0 0;
          font-weight: bold;
        }

        .invoice-title {
          font-size: 24px;
          font-weight: bold;
          color: #003d82;
          text-align: center;
          margin: 0;
        }

        .invoice-subtitle {
          font-size: 12px;
          text-align: center;
          margin: 3px 0;
          font-weight: bold;
        }

        .invoice-note {
          font-size: 10px;
          text-align: center;
          margin: 0;
          color: #666;
        }

        .header-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 11px;
        }

        .header-table td {
          border: 1px solid #ccc;
          padding: 6px;
        }

        .header-label {
          background-color: #f0f0f0;
          font-weight: bold;
          width: 50%;
        }

        .header-value {
          text-align: center;
        }

        /* Billing Section */
        .billing-section {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px;
          margin-bottom: 20px;
          border: 1px solid #ccc;
        }

        .billing-from, .shipment-from {
          padding: 15px;
          border-right: 1px solid #ccc;
        }

        .shipment-from {
          border-right: none;
        }

        .section-title {
          background-color: #003d82;
          color: white;
          padding: 8px 12px;
          margin: -15px -15px 12px -15px;
          font-size: 12px;
          font-weight: bold;
          text-transform: uppercase;
        }

        .qr-box {
          text-align: center;
          margin-bottom: 15px;
        }

        .qr-box svg {
          border: 1px solid #ccc;
          padding: 5px;
        }

        .company-info, .customer-info {
          font-size: 11px;
          line-height: 1.1;
        }

        .company-info p, .customer-info p {
          margin: 4px 0;
        }

        /* Customer Section */
        .customer-section {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px;
          margin-bottom: 20px;
          border: 1px solid #ccc;
        }

        .billed-to, .shipped-to {
          padding: 15px;
          border-right: 1px solid #ccc;
        }

        .shipped-to {
          border-right: none;
        }

        /* Invoice Details */
        .invoice-details-row {
          padding: 8px 15px;
          background-color: #f9f9f9;
          border: 1px solid #ccc;
          font-size: 11px;
          margin-bottom: 20px;
        }

        .invoice-details-row p {
          margin: 0;
        }

        /* Items Table */
        .items-table-wrapper {
          margin-bottom: 20px;
          overflow-x: auto;
        }

        .items-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 10px;
        }

        .items-table th {
          background-color: #f0f0f0;
          border: 1px solid #ccc;
          padding: 8px;
          font-weight: bold;
          text-align: center;
        }

        .items-table td {
          border: 1px solid #ccc;
          padding: 8px;
          text-align: right;
        }

        .items-table td.text-center {
          text-align: center;
        }

        .items-table td.text-left {
          text-align: left;
        }

        .item-description {
          text-align: left !important;
        }

        .item-variant {
          font-size: 9px;
          color: #999;
          display: block;
          margin-top: 2px;
        }

        .totals-row {
          background-color: #f9f9f9;
          font-weight: bold;
        }

        /* Totals Section */
        .totals-section {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px;
          margin-bottom: 20px;
        }

        .totals-left {
          padding: 15px;
          border: 1px solid #ccc;
          background-color: #f9f9f9;
        }

        .total-words {
          font-size: 11px;
        }

        .total-words p {
          margin: 4px 0;
        }

        .summary-table {
          width: 100%;
          border-collapse: collapse;
          font-size: 11px;
        }

        .summary-table tr {
          border: 1px solid #ccc;
        }

        .summary-table td {
          padding: 8px;
          border-right: 1px solid #ccc;
        }

        .summary-table td:last-child {
          border-right: none;
        }

        .summary-label {
          background-color: #f0f0f0;
          font-weight: bold;
          width: 50%;
        }

        .summary-value {
          text-align: right;
          font-weight: bold;
        }

        .grand-total-row {
          background-color: #003d82;
          color: white;
        }

        .grand-total-row .summary-label,
        .grand-total-row .summary-value {
          color: white;
        }

        /* Additional Details */
        .additional-details {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 20px;
          margin-bottom: 20px;
        }

        .details-left, .details-right {
          font-size: 10px;
          line-height: 1.1;
        }

        .detail-heading {
          background-color: #003d82;
          color: white;
          padding: 8px 12px;
          margin: 0 0 12px 0;
          font-size: 11px;
          font-weight: bold;
        }

        .details-left p, .details-right p {
          margin: 4px 0;
        }

        .signature-area {
          margin-top: 30px;
          text-align: center;
        }

        .signature-line, .seal-line {
          height: 40px;
          border: 1px dashed #ccc;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 10px;
          color: #999;
          margin: 8px 0;
        }

        /* Terms Section */
        .terms-section {
          margin-bottom: 20px;
          border: 1px solid #ccc;
          padding: 15px;
        }

        .terms-content, .important-notes {
          font-size: 10px;
          line-height: 1.1;
          margin-top: 8px;
        }

        .terms-content ol, .important-notes ul {
          margin: 0;
          padding-left: 20px;
        }

        .terms-content li, .important-notes li {
          margin-bottom: 4px;
        }

        .tax-notice {
          background-color: #fff3cd;
          border: 1px solid #ffeaa7;
          padding: 10px;
          margin-top: 10px;
          border-radius: 4px;
          font-size: 10px;
          font-weight: bold;
          text-align: center;
        }

        /* Footer */
        .invoice-footer {
          background-color: #003d82;
          color: white;
          padding: 15px;
          text-align: center;
          font-size: 11px;
          border-radius: 4px;
          margin-top: 20px;
          display: flex;
          justify-content: center;
          gap: 30px;
          flex-wrap: wrap;
        }

        .invoice-footer span {
          font-weight: bold;
        }

        /* Print Styles */
        @media print {
          body * {
            visibility: hidden;
          }
          .printable-area,
          .printable-area * {
            visibility: visible;
          }
          .printable-area {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            box-shadow: none;
            border: none;
            page-break-after: always;
          }
          .d-print-none {
            display: none !important;
          }
          .main-wrapper {
            background-color: white !important;
            padding: 0 !important;
          }
          .invoice-container {
            box-shadow: none;
            border: none;
            padding: 0;
            max-width: 100%;
            margin: 0;
          }
        }

        @media (max-width: 768px) {
          .header-section {
            grid-template-columns: 1fr;
          }

          .billing-section,
          .customer-section,
          .additional-details,
          .totals-section {
            grid-template-columns: 1fr;
          }

          .billing-from, .shipment-from,
          .billed-to, .shipped-to,
          .details-left, .details-right {
            border-right: none;
            border-bottom: 1px solid #ccc;
          }

          .items-table {
            font-size: 8px;
          }

          .items-table th,
          .items-table td {
            padding: 4px;
          }

          .invoice-container {
            padding: 10px;
          }
        }
      `}</style>
    </>
  );
}

export default ViewOrder;